import { render, staticRenderFns } from "./edit-dialog.vue?vue&type=template&id=7a4d18f3&scoped=true&"
import script from "./edit-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-dialog.vue?vue&type=style&index=0&id=7a4d18f3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4d18f3",
  null
  
)

export default component.exports